import { useMutation } from "react-query";
import { EditarConsumoUnidadeForm } from "../typings/index";
import http from "infra/http";

function useSaveConsumoUnidade(id: string, unidadeId: string) {
  return useMutation(
    `/v1/consumo/${id}/unidades/${unidadeId}`,
    (data: EditarConsumoUnidadeForm) => {
      return http.put(`/v1/consumo/${id}/unidades/${unidadeId}`, data);
    },
    { retry: false }
  );
}

export default useSaveConsumoUnidade;
